// bwme-blink.js — permanent nav blink
document.addEventListener('DOMContentLoaded', function () {
  function normalize(t){
    return t ? t.replace(/[\u2018\u2019\u02BC`’ʼ]/g,"'").replace(/\s+/g,' ').trim().toLowerCase() : '';
  }
  function isTargetText(t){
    const n = normalize(t);
    return n === "beauty world '26" || (n.includes('beauty world') && n.includes('26'));
  }

  const candidates = document.querySelectorAll('.wt-page-nav-mega__link__text, .wt-page-nav-mega__link__text--underline, a span, span');
  let el = null;
  candidates.forEach(node => {
    if(isTargetText(node.textContent)) el = node;
  });

  if(!el) return; // not found (different page, etc.)

  const blinkColor = '#9d5e74';
  const normalColor = getComputedStyle(el).color || 'rgb(0,0,0)';
  let state = 0;
  const parentA = el.closest('a');

  setInterval(() => {
    const color = state ? normalColor : blinkColor;
    el.style.setProperty('color', color, 'important');
    if (parentA) parentA.style.setProperty('color', color, 'important');
    state = 1 - state;
  }, 500);
});